export default __webpack_public_path__ + "static/10-cyborg-5734c28eb3cda3a8801fa326aacf66c8.png";